<script setup lang="ts">
import OrthoNeedsAddEditForm from "@/components/models/patient/forms/OrthoNeedsAddEditForm.vue";
import { usePatient } from "@/composables/models/patient/usePatient";
import { useAbility } from "@casl/vue";
import { useI18n } from "vue-i18n";
import QuestionnaireLayout from "@/components/models/patient/questionnaire/QuestionnaireLayout.vue";
import QuestionnaireSideBar from "@/components/models/patient/questionnaire/QuestionnaireSideBar.vue";
import { definePage } from "unplugin-vue-router/runtime";
import { useUrlQuery } from "@/composables/shared/filters/useUrlSearch";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.orthoNeedsPlan" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__ORTHONEEDSPATIENT);
    },
  },
});
const { t } = useI18n();
const defaultValues = useUrlQuery({ patient: String });

const { data: patient, isLoading: isPatientLoading } = usePatient(
  {
    id: defaultValues.patient,
  },
  { redirectOnNotFound: true }
);
</script>

<template>
  <v-skeleton-loader :loading="isPatientLoading">
    <questionnaire-layout :title="t('models.patient.orthoNeeds.title')">
      <ortho-needs-add-edit-form
        v-if="patient"
        :patient="patient"
      />

      <div
        v-else
        class="tw:text-center"
      >
        {{ t("models.patient.shared.noPatient") }}
      </div>

      <template #sidebar>
        <questionnaire-side-bar :patient="patient" />
      </template>
    </questionnaire-layout>
  </v-skeleton-loader>
</template>

<style scoped></style>
